import Vue from "vue";
import Vuex from "vuex";
import mainStore from "./state/modules/mainStore.js"

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    mainStore
  }
});
